import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { HOOKS_SETTINGS } from '../constants';

const { CONTROLLERS: { TAX_BUCKET_INFO: { BASE, VERSION } } } = USER;
const { METHOD: { POST } } = HOOKS_SETTINGS;

export const useTaxBucketInfoQuery = ({
  customerId, fullTimeFreelancer, annualExpense, annualIncome, annualSalary, onSuccess,
}: { customerId: string, fullTimeFreelancer: boolean, annualExpense: number, annualIncome: number, annualSalary: number, onSuccess?: () => void, }) => useQuery(
  'tax-bucket-info',
  async () => {
    if (!customerId || !annualExpense || !annualIncome) {
      return null;
    }
    const { data } = await httpService({
      url: `${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}`,
      method: POST,
      data: {
        annualExpense,
        annualIncome,
        annualSalary,
        fullTimeFreelancer,
      },
    });
    return data;
  },
  {
    cacheTime: 0,
    enabled: false,
    onSuccess: () => { if (onSuccess) onSuccess(); },
  },
);
